import React, { useEffect, useState } from "react";
import { Form, Select, message } from "antd";
import AllergensApi from "../../Apis/AllergensApi";
import ProductApi from "../../Apis/ProductApi";

const AllergenStock = ({ product }) => {
    const [Allergens, setAllergens] = useState([]);
    const [loading, setLoading] = useState(false);
    const [TotalPageNew, setTotalPageNew] = useState(null);
    const [page, setPage] = useState(0);

    const [selectedAllergens, setSelectedAllergens] = useState(
        product?.allergens?.map((a) => a.id) || []
    );

    // Fetch allergens paginated
    const fetchAllergens = async () => {
        try {
            setLoading(true);
            const response = await AllergensApi.ListAllergensApi(page, 10);

            setTotalPageNew(response.totalPages);
            setAllergens((prev) => [...prev, ...response?.payloadDto]);
            setPage((prev) => prev + 1);
        } catch (error) {
            console.error("Error fetching allergens:", error);
        } finally {
            setLoading(false);
        }
    };

    const handleScroll = (e) => {
        const nearBottom =
            e.target.scrollHeight - e.target.scrollTop <= e.target.clientHeight + 1;

        if (nearBottom && TotalPageNew > page) {
            fetchAllergens();
        }
    };

    useEffect(() => {
        fetchAllergens();
    }, []);

    const removeDates = (obj) => {
        const newObj = Array.isArray(obj) ? [] : {};

        for (const key in obj) {
            if (!obj.hasOwnProperty(key)) continue;

            const value = obj[key];

            // Remove fields with names containing date indicators
            if (/date|Date|created|Created|modified|Modified/i.test(key)) {
                continue; // skip this field entirely
            }

            // Remove timestamp numbers (e.g., 1763836200000)
            if (typeof value === "number" && value.toString().length >= 10) {
                continue;
            }

            // Remove date-like strings (YYYY-MM-DD or DD-MM-YYYY)
            if (typeof value === "string" && /\d{4}-\d{2}-\d{2}/.test(value)) {
                continue;
            }
            if (typeof value === "string" && /\d{2}-\d{2}-\d{4}/.test(value)) {
                continue;
            }

            // Recurse for nested objects
            if (value !== null && typeof value === "object") {
                newObj[key] = removeDates(value);
            } else {
                newObj[key] = value;
            }
        }

        return newObj;
    };


    const handleAllergenChange = async (values) => {
        setSelectedAllergens(values);

        if (!product?.id) return;

        const allergensArr = values.map(id => ({ id }));
        const allergensString = values.join(",");
        const lastSelected = values.length > 0 ? values[values.length - 1] : null;

        // Deep copy
        let cleanedProduct = JSON.parse(JSON.stringify(product));

        // Remove ALL date fields anywhere
        cleanedProduct = removeDates(cleanedProduct);

        // Rebuild supplierDTO with only IDs
        if (cleanedProduct.supplierDTO) {
            cleanedProduct.supplierDTO = cleanedProduct.supplierDTO.map(s => ({ id: s.id }));
        }

        // Rebuild institutionDTO
        if (cleanedProduct.institutionDTO) {
            cleanedProduct.institutionDTO = { id: cleanedProduct.institutionDTO.id };
        }

        // Rebuild tenantDTO
        if (cleanedProduct.tenantDTO) {
            cleanedProduct.tenantDTO = { id: cleanedProduct.tenantDTO.id };
        }

        // Rebuild storageSuggestionDTO
        if (cleanedProduct.storageSuggestionDTO) {
            cleanedProduct.storageSuggestionDTO = { id: cleanedProduct.storageSuggestionDTO.id };
        }

        // Final payload
        const payload = JSON.stringify({
            ...cleanedProduct,
            allergen: allergensString,
            allergens: allergensArr,
            productCreateDate: product.productCreateDate,
            allergensDTO: lastSelected ? { id: lastSelected } : null
        });

        console.log("FINAL CLEAN PAYLOAD:", payload);

        try {
            await ProductApi.PutProduct(product.id, payload);
            message.success("Allergens updated successfully!");
        } catch (error) {
            console.error("Error updating allergens", error);
            message.error("Failed to update allergens");
        }
    };

    return (
        <Form.Item
            name="Allergen"
            label="Allergen :"
            className="text-lable"
            rules={[
                {
                    required: true,
                    message: "Please Select Allergen.",
                },
            ]}
        >
            <Select
                mode="multiple"
                className="control-Select mb-1"
                placeholder="Select Allergens"
                onPopupScroll={handleScroll}
                value={selectedAllergens}
                onChange={handleAllergenChange} 
            >
                {Allergens.map((item) => (
                    <Select.Option key={item.id} value={item.id}>
                        {item.allergensName}
                    </Select.Option>
                ))}

                {loading && (
                    <Select.Option disabled key="loading" value="loading">
                        Loading...
                    </Select.Option>
                )}
            </Select>
        </Form.Item>
    );
};

export default AllergenStock;
